import React, { Component } from 'react';
import GroupedDataSource from '~/Api/DataSource/GroupedDataSource';
import { DataSource } from '~/Api/Product/SearchableDataSource';
import ActivityIndicator from '~/UI/ActivityIndicator';
import Checkbox from '~/UI/Checkbox/Checkbox';
import CountryIcon from '~/UI/CountryIcon/CountryIcon';
import { Link } from '~/UI/Button';
import Select from '~/UI/Select';

import buttonPrimaryAltMiniStyles from '~/UI/Button/primary-alt-mini.less';
import styles from './styles.less';

export const ALL_DATA_SOURCES_ID = 'ALL_DATA_SOURCES_ID';
export const ALL_DATA_SOURCES_NAME = 'All data sources';
interface Props {
	groupedDataSources: GroupedDataSource[] | null;
	dataSources: DataSource[] | null;
	currentTypes: Set<string> | null;
	isFetching: boolean;
	selectedGrouppingType: string | null;
	onFetch(): void;
	onChange(selection: Set<string> | null, selectedGrouppingType: string | null, groupName: string | null): void;
}

export default class DatasourceSelect extends Component<Props> {
	static defaultProps = {
		currentTypes: null,
	};

	componentDidMount() {
		this.props.onFetch();
	}

	handleCheckboxChange(checked: boolean, type: string, groupedTypeId: string, groupTypeName: string | null) {
		const { dataSources, currentTypes, onChange } = this.props;

		if (currentTypes === null) {
			if (checked) {
				return;
			}

			const types = new Set((dataSources || []).map((dataSource) => dataSource.type));
			types.delete(type);
			onChange(types, groupedTypeId, groupTypeName);
			return;
		}

		const types = new Set(currentTypes);
		if (checked) {
			types.add(type);
		} else {
			types.delete(type);
		}

		onChange(types.size === (dataSources || []).length ? null : types, groupedTypeId, groupTypeName);
	}

	private handleSelectGrouppedSourceRequest = (selectedGroupId: string, optionName: string | null) => {
		const { groupedDataSources, onChange } = this.props;
		if (selectedGroupId !== ALL_DATA_SOURCES_ID) {
			const groupSources = (groupedDataSources || []).find(
				(groupedDataSource) => groupedDataSource.id === selectedGroupId
			);

			if (groupSources) {
				onChange(new Set(groupSources.dataSources.map((dataSource) => dataSource.type)), selectedGroupId, optionName);
			}
		} else {
			onChange(null, selectedGroupId, optionName);
		}
	};

	render() {
		const { dataSources, groupedDataSources, currentTypes, isFetching, selectedGrouppingType, onChange } = this.props;

		if (isFetching) {
			return <ActivityIndicator />;
		}

		const sortedDataSources = dataSources?.sort((a, b) => a.country.name.localeCompare(b.country.name));
		groupedDataSources?.forEach((groupedDataSource) =>
			groupedDataSource.dataSources.sort((a, b) => a.country.name.localeCompare(b.country.name))
		);

		const options: {
			id: string;
			name: string;
			dataSources: DataSource[];
		}[] = [{ id: ALL_DATA_SOURCES_ID, name: ALL_DATA_SOURCES_NAME, dataSources: sortedDataSources || [] }]
			.concat(groupedDataSources || [])
			.map((groupedDataSource) => ({
				id: groupedDataSource.id,
				name: groupedDataSource.name,
				dataSources: groupedDataSource.dataSources,
			}));

		const actualSelectedGroupDataSourceId = selectedGrouppingType || options[0]?.id;

		if (options.every((option) => option.dataSources.length === 0)) {
			return null;
		}

		const selectedOption = options.find((candidate) => candidate.id === actualSelectedGroupDataSourceId);

		return (
			<>
				<div className={styles.buttons}>
					<div className={styles.leftButton}>
						<Link
							styles={buttonPrimaryAltMiniStyles}
							onClick={() => {
								if (selectedOption) {
									onChange(
										new Set((selectedOption.dataSources || []).map((source) => source.type)),
										selectedOption.id,
										selectedOption.name
									);
								}
							}}
						>
							Select All
						</Link>
					</div>
					<div className={styles.rightButton}>
						<Link
							styles={buttonPrimaryAltMiniStyles}
							onClick={() => {
								onChange(new Set(), ALL_DATA_SOURCES_ID, ALL_DATA_SOURCES_NAME);
							}}
						>
							Unselect All
						</Link>
					</div>
				</div>
				<div className={styles.headRow}>
					<Select
						id='grouped-datasource-select'
						value={String(actualSelectedGroupDataSourceId)}
						onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
							const selectedOptionId = event.currentTarget.value;

							const name = options.find((groupOption) => groupOption.id === selectedOptionId)?.name;
							this.handleSelectGrouppedSourceRequest(selectedOptionId, name || null);
						}}
					>
						{options.map((groupedDataSource) => (
							<option key={groupedDataSource.id} value={groupedDataSource.id}>
								{groupedDataSource.name}
							</option>
						))}
					</Select>
					<div>
						{selectedOption?.dataSources.map((dataSource) => (
							<div className={styles.row} key={dataSource.type}>
								<Checkbox
									checked={currentTypes === null || currentTypes.has(dataSource.type)}
									id={dataSource.type}
									onChange={(checked) =>
										this.handleCheckboxChange(checked, dataSource.type, selectedOption.id, selectedOption.name)
									}
								>
									<div className={styles.rowContent}>
										<div className={styles.rowIcon}>
											<CountryIcon code={dataSource.country.alpha2} name={dataSource.country.name} />
										</div>
										{dataSource.country.name}
										{' - '}
										{dataSource.shortName}
									</div>
								</Checkbox>
							</div>
						))}
					</div>
				</div>
			</>
		);
	}
}
